import { ApiError } from '../instance/error';
import {
  ErrorHandlerDeps as ExecuteErrorHandlerDeps,
  executeErrorAction,
} from './execute-error-action';
import { resolveErrorAction } from './resolve-error-action';
import { ErrorAction } from './types';

export type ErrorHandlerDeps = ExecuteErrorHandlerDeps;

export interface HandleApiErrorResult {
  action: ErrorAction;
  handled: boolean;
}

export function handleApiError(
  error: ApiError,
  deps: ErrorHandlerDeps,
): HandleApiErrorResult {
  const resolved = resolveErrorAction(error);
  executeErrorAction(resolved, deps);

  return {
    action: resolved.action,
    handled: resolved.handled,
  };
}
